import { render, staticRenderFns } from "./MaydayArticleEditor.vue?vue&type=template&id=721b7a81&scoped=true&"
import script from "./MaydayArticleEditor.vue?vue&type=script&lang=js&"
export * from "./MaydayArticleEditor.vue?vue&type=script&lang=js&"
import style0 from "./MaydayArticleEditor.vue?vue&type=style&index=0&id=721b7a81&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721b7a81",
  null
  
)

export default component.exports